module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Wolterstorff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Nicholas Wolterstorff")]), _vm._v(" is Noah Porter Professor Emeritus of Philosophical Theology at Yale University. Before going to Yale he taught philosophy at Calvin College in Grand Rapids, Michigan, for thirty years. His other books include "), _c('I', [_vm._v("Justice in Love, Educating for Shalom, The God We Worship")]), _vm._v(", and "), _c('I', [_vm._v("Lament for a Son")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tXZk8R/tc-custom/9781467443296.jpg?1728851918151",
      "alt": "This image is the cover for the book The God We Worship, Kantzer Lectures in Revealed Theology (KLRT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The God We Worship, Kantzer Lectures in Revealed Theology (KLRT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In "), _c('i', [_vm._v("The God We Worship")]), _vm._v(" Nicholas Wolterstorff takes a ground-up approach to liturgical theology, examining the oft-hidden implications of traditional elements of liturgy. Given that “no liturgy has ever been composed from scratch,” Wolterstorff argues that the assumptions taken into worship are key to perceiving the real depths of historical Christianity’s understanding of God."), _c('br'), _c('br'), _vm._v("Across the liturgies of the Orthodox, Catholic, Episcopal, Lutheran, and Reformed churches, Wolterstorff highlights theologically neglected elements of God, such as an implicit liturgical understanding of God as listener. A dissection of liturgy is not only interesting, Wolterstorff argues, but crucial for reconciling differences between the God studied by theologians and the God worshiped by churchgoers on Sunday.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0